import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { MAPS_EXPORT_CREATE } from './maps-graphql/queries';
import type { MapsExportFormat, MapsExportResult } from '../models/maps.types';

export interface ExportRequest {
    searchId: string;
    candidateIds: string[];
    format: MapsExportFormat;
    includeSummaries: boolean;
}

@Injectable({ providedIn: 'root' })
export class ExportService {
    constructor(private readonly apollo: Apollo) {}

    async Create(req: ExportRequest): Promise<MapsExportResult> {
        const result = await firstValueFrom(
            this.apollo.mutate<{ mapsExportCreate: MapsExportResult }>({
                mutation: MAPS_EXPORT_CREATE,
                variables: { input: req },
            })
        );
        if (!result.data?.mapsExportCreate) {
            throw new Error('mapsExportCreate returned empty payload');
        }
        return result.data.mapsExportCreate;
    }
}
